import { Link } from "react-router-dom";
import Header from "@/components/Header";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Header />
      <div className="pt-40 pb-20 max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <div className="text-xs tracking-[0.5em] gold uppercase">Erreur 404</div>
        <h1 className="mt-4 font-serif text-white text-6xl">Introuvable</h1>
        <p className="mt-3 text-gray-400">La page recherchée n'existe pas.</p>
        <Link to="/" className="mt-8 inline-block btn-gold">Retour à l'accueil</Link>
      </div>
    </div>
  );
}
